import KeycloakClient from '../clients/shared/KeycloakClient';
import MASClient from '../clients/shared/MASClient';
import { FETCH_MAS_TOKEN } from '../actionTypes/shared/apiActionTypes';
import { apiActionCreator } from '../actionCreators';

const fetchMasToken = () => async dispatch => {
    const keycloakToken = KeycloakClient.getToken();
    const additionalApiParams = {
        apiParams: [keycloakToken],
    };
    await apiActionCreator(dispatch, FETCH_MAS_TOKEN, MASClient.fetchMASToken, additionalApiParams);
};

export default fetchMasToken;
